import React, { useContext, useEffect } from 'react';
import { SocketContext } from './SocketContext.js';
import SoundManager from '../components/SoundManager';
import { CountdownCircleTimer } from 'react-countdown-circle-timer'

const Countdown = ({ key, duration, onComplete }) => {
    const socket = useContext(SocketContext);

    const handleTimerComplete = () => {
        SoundManager.stopClickTickingSound();
        if (onComplete) {
            onComplete();
        }
    };

    const handleTimerChange = (time) => {
        if (time == 8) {
            SoundManager.playClockTickingSound();
        }
        if (time == 0) {
            SoundManager.stopClickTickingSound();
            SoundManager.playAlarmSound();
        }
    };

    return (
        <div>
            <CountdownCircleTimer
                isPlaying
                size={75}
                key={key}
                duration={duration}
                colors={['#004777', '#F7B801', '#F7B801','#A33C01', '#A30000']}
                colorsTime={[90, 60, 40, 20, 0]}
                onComplete={handleTimerComplete}
                onUpdate={handleTimerChange}
            >
                {({ remainingTime }) => (
                    remainingTime)}
            </CountdownCircleTimer>
        </div>
    );
};

export default Countdown;